import {Injectable} from "@angular/core";

interface Group {
    NeoPermissionAction: NeoPermissionAction[]
}

interface NeoPermissionAction {
    ActionKey: string,
    Access: boolean,
}

@Injectable()
export class NeoACLService {

    private static _abilities: string[];
    private static _type: string = '';

    constructor() {}

    /**
     * Obtiene las disponibilidad
     * @returns {string[]}
     */
    getAbilities(): string[] {
        return NeoACLService._abilities || [];
    }

    /**
     * Setea las disponibilidad
     *
     * @param value Array de NeoPermissionAction
     */
    setAbilities(value: Group[] = []) {
        if (!Array.isArray(value)) {
            value = [];
        }

        NeoACLService._abilities = value.reduce((r: string[], v) => {

            let p: string[] = v.NeoPermissionAction.filter(v => v.Access).map(v => v.ActionKey.toLowerCase());

            r.push(...p);

            return r;
        }, []);
    }

    /**
     * Obtiene el tipo de usuario
     * @returns {string}
     */
    getUserType(): string {
        return NeoACLService._type;
    }

    /**
     * Setea el tipo de usuario
     * @param {string} value
     */
    setUserType(value: string) {
        NeoACLService._type = value;
    }

    /**
     * Comprueba si tiene permisos
     *
     * @returns {boolean}
     * @param actions
     */
    public can(actions: string[]): boolean {
        if (this.getUserType() == 'superadmin' || this.getUserType() == 'god') {
            return true;
        }

        actions = actions || [];

        if (this.getAbilities().length > 0) {

            for (let action of actions) {
                let isPreset = false;
                let reg = new RegExp(action, 'i');

                let avails = this.getAbilities();
                for (let ua of avails) {
                    isPreset = reg.test(ua);
                    if (isPreset) {
                        break
                    }
                }

                if (!isPreset) {
                    return false;
                }
            }

            return true;
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-acl/neo-acl.ts